import { getTotalTypesLabel } from "helpers/metrics/legacy-metrics";
import * as React from "react";
import { IPinnedRowsRenderersComponentProps } from "../pinned-row-constants";

export const TotalsRenderersLabelColumn: React.FunctionComponent<IPinnedRowsRenderersComponentProps> = ({
    totalType,
    style,
}) => {
    const value = getTotalTypesLabel(totalType);

    return (
        <div style={style} className="planHeader">
            <div className="planTitle">{value}</div>
            {/* <ul className="planRows">
                <li className="planLabel">Plan</li>
                <li className="actualLabel">Total</li>
                <li className="diffLabel">Diff</li>
            </ul> */}
        </div>
    );
};
